import React from "react"
import PropTypes from "prop-types"
import { message } from 'antd'
import Screen from '../../Components/Screen'
import Header from "./Components/Header"
import SettingsPanel from "./Components/SettingsPanel"
import StatsBar from "./Components/StatsBar"
import RunsTable from "./Components/RunsTable"
import DocumentsModal from "./Components/DocumentsModal"
import SelectiveRunModal from "./Components/SelectiveRunModal/SelectiveRunModal"

export default class _ToolBoxTalk_ extends React.PureComponent {

  static propTypes = {
    componentDidMount: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    settingsLoading: PropTypes.bool.isRequired,
    runs: PropTypes.array.isRequired,
    runsLoading: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    runDetails: PropTypes.object.isRequired,
    onChangeTable: PropTypes.func.isRequired,
    onViewRunDetails: PropTypes.func.isRequired,
    onRefreshRuns: PropTypes.func.isRequired,
    onClickSettings: PropTypes.func.isRequired,
    onManualRun: PropTypes.func.isRequired,
    onFetchRuns: PropTypes.func.isRequired,
    isRunning: PropTypes.bool,
    manualRunResult: PropTypes.object,
    manualRunError: PropTypes.string,
    documents: PropTypes.array,
    documentsLoading: PropTypes.bool,
    documentsUploading: PropTypes.bool,
    statistics: PropTypes.object,
    statisticsLoading: PropTypes.bool,
    onFetchDocuments: PropTypes.func.isRequired,
    onUploadDocument: PropTypes.func.isRequired,
    onDeleteDocument: PropTypes.func.isRequired,
    onToggleDocumentActive: PropTypes.func.isRequired,
    onFetchStatistics: PropTypes.func.isRequired,
  }

  state = {
    documentsModalVisible: false,
  }

  componentDidMount = () => this.props.componentDidMount()

  componentDidUpdate(prevProps) {
    const { manualRunResult, manualRunError } = this.props
    
    // Show success message when manual run completes
    if (manualRunResult && manualRunResult !== prevProps.manualRunResult) {
      message.success(`TBT distribution completed successfully! Sent to ${(manualRunResult.run && manualRunResult.run.subcontractors_count) || 0} subcontractors.`)
    }
    
    // Show error message when manual run fails
    if (manualRunError && manualRunError !== prevProps.manualRunError) {
      message.error(manualRunError)
    }
  }

  handleRunNow = () => {
    // Open the selective run modal instead of running directly
    this.selectiveRunModalRef.show()
  }

  handleSelectiveRunComplete = (runResult) => {
    // Refresh the runs table when selective run completes
    const { onFetchRuns } = this.props
    onFetchRuns({ page: 1, per_page: 20 }) // Refresh first page with proper data fetch
    
    // Note: Success message is already shown by SelectiveRunModal, no need to duplicate
  }

  handleManageDocuments = () => {
    const { onFetchDocuments, onFetchStatistics } = this.props
    this.setState({ documentsModalVisible: true })
    onFetchDocuments()
    onFetchStatistics()
  }

  handleCloseDocumentsModal = () => {
    this.setState({ documentsModalVisible: false })
  }

  handleRefreshDocuments = () => {
    const { onFetchDocuments, onFetchStatistics } = this.props
    onFetchDocuments()
    onFetchStatistics()
  }

  render () {
    const {
      settings,
      settingsLoading,
      runs,
      runsLoading,
      pagination,
      runDetails,
      onChangeTable,
      onViewRunDetails,
      onRefreshRuns,
      onClickSettings,
      isRunning,
      documents,
      documentsLoading,
      documentsUploading,
      statistics,
      onUploadDocument,
      onDeleteDocument,
      onToggleDocumentActive,
    } = this.props
    
    const { documentsModalVisible } = this.state

    return (

      <Screen>

        <Header 
          onClickManageDocuments={this.handleManageDocuments}
          onClickSettings={onClickSettings}
          onClickRunNow={this.handleRunNow}
          isRunning={isRunning}
        />

        <SettingsPanel 
          settings={settings}
          loading={settingsLoading}
        />

        <StatsBar
          statistics={statistics || {}}
          loading={!!this.props.statisticsLoading}
        />

        <RunsTable 
          runs={runs}
          fetching={runsLoading}
          pagination={pagination}
          runDetails={runDetails}
          onChangeTable={onChangeTable}
          onViewRunDetails={onViewRunDetails}
          onRefreshRuns={onRefreshRuns}
        />

        <DocumentsModal
          visible={documentsModalVisible}
          onClose={this.handleCloseDocumentsModal}
          documents={documents}
          loading={documentsLoading}
          uploading={documentsUploading}
          statistics={statistics}
          onUpload={onUploadDocument}
          onDelete={onDeleteDocument}
          onToggleActive={onToggleDocumentActive}
          onRefresh={this.handleRefreshDocuments}
        />

        <SelectiveRunModal
          ref={ref => this.selectiveRunModalRef = ref}
          onRunComplete={this.handleSelectiveRunComplete}
        />

      </Screen>

    )
  }
}
